/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum FormatType {
  APNG = "APNG",
  LOTTIE = "LOTTIE",
  PNG = "PNG",
  Unknown = "Unknown",
}

export enum MentionType {
  Channel = "Channel",
  Member = "Member",
  Role = "Role",
}

export enum MessageType {
  Call = "Call",
  ChannelFollowAdd = "ChannelFollowAdd",
  ChannelIconChange = "ChannelIconChange",
  ChannelNameChange = "ChannelNameChange",
  ChannelPinnedMessage = "ChannelPinnedMessage",
  ChatInputCommand = "ChatInputCommand",
  ContextMenuCommand = "ContextMenuCommand",
  Default = "Default",
  GuildDiscoveryDisqualified = "GuildDiscoveryDisqualified",
  GuildDiscoveryGracePeriodFinalWarning = "GuildDiscoveryGracePeriodFinalWarning",
  GuildDiscoveryGracePeriodInitialWarning = "GuildDiscoveryGracePeriodInitialWarning",
  GuildDiscoveryRequalified = "GuildDiscoveryRequalified",
  GuildInviteReminder = "GuildInviteReminder",
  GuildMemberJoin = "GuildMemberJoin",
  RecipientAdd = "RecipientAdd",
  RecipientRemove = "RecipientRemove",
  Reply = "Reply",
  ThreadCreated = "ThreadCreated",
  ThreadStarterMessage = "ThreadStarterMessage",
  Unknown = "Unknown",
  UserPremiumGuildSubscription = "UserPremiumGuildSubscription",
  UserPremiumGuildTier1 = "UserPremiumGuildTier1",
  UserPremiumGuildTier2 = "UserPremiumGuildTier2",
  UserPremiumGuildTier3 = "UserPremiumGuildTier3",
}

//==============================================================
// END Enums and Input Objects
//==============================================================



// WEBPACK FOOTER //
// ./src/__generated__/globalTypes.ts